module.exports = __webpack_public_path__ + "img/05.890e0ad6.jpg";